module.exports = "/_next/static/images/GooglePlayButton-c83af8e46bb8a9db3b1a0dcf065e3f55.svg";